const editorsPicks = (
  state = {
    campaign2018: {
      themeColor: "#F8F6F6",
      title: "2018",
      desc:
        "Make a collection of your 2018 memories with these poster-like images created by our designers.",
      picks: {
        landscape: {
          src:
            "https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:best/v1539083214/mondaybee/assets/campaign_2018/Landscape.jpg",
          placeholder:
            "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,h_21,q_auto:best,w_15/v1539083214/mondaybee/assets/campaign_2018/Landscape.jpg",
          orientation: "portrait"
        },
        hotairballoon: {
          src:
            "https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:best/v1539083214/mondaybee/assets/campaign_2018/Hot_Air_Balloon.jpg",
          placeholder:
            "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,h_21,q_auto:best,w_15/v1539083214/mondaybee/assets/campaign_2018/Hot_Air_Balloon.jpg",
          orientation: "portrait"
        },
        earth: {
          src:
            "https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:best/v1539083214/mondaybee/assets/campaign_2018/Earth.jpg",
          placeholder:
            "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,w_21,q_auto:best,h_15/v1539083214/mondaybee/assets/campaign_2018/Earth.jpg",
          orientation: "landscape"
        }
      }
    }
  },
  action
) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default editorsPicks;



// WEBPACK FOOTER //
// ./src/reducers/mosaic/editorsPicks.js